export const POST_MESSAGE_EVENT = {
    PAYMENT: {
        CANCEL_USER: 'CANCEL_PAYMENT_USER',
        COMPLETE: 'COMPLETE_PAYMENT',
        CANCEL_OPERATOR: 'CANCEL_PAYMENT_OPERATOR',
    },
    DEPOSIT: {
        COMPLETE: 'COMPLETE_DEPOSIT',
        CANCEL_USER: 'CANCEL_DEPOSIT_USER',
        FAIL: 'FAIL_DEPOSIT',
    },
    INVALID_QR: 'INVALID_QR',
    OPEN_URL: 'OPEN_URL',
    RETURN_TO_SITE: 'RETURN_TO_SITE',
} as const
